import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newConsignee({ commit }) {
    let consigneeDetail = {
      consignee_name: $(".consignee_name").val()
    };
    $(".creatingConsignee").hide();
    $(".creatingConsigneeLoader").show();
    baseurl.post(rt.newConsignees, consigneeDetail).then(res => {
      $(".creatingConsignee").show();
      $(".creatingConsigneeLoader").hide();

      if (res.data.code === 200) {
        window.$("#new-consignee").modal("hide");
        suc.consigneesCreateSuccess();
        $(".form-control").val("");
        setTimeout(() => {
          commit("STORE_CONSIGNEES", res.data.consignees);
        }, 1000);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.ConsigneesExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingConsignees();
      } else if (res.data.code === 405) {
        window.$("#new-consignee").modal("hide");
        ers.noPermissionToCreate();
      } else if (res.data.code === 506) {
        window.$("#new-consignee").modal("hide");
        ses.sessionComplete();
      }
    });
  },

  loadConsignees({ commit }) {
    baseurl.get(rt.loadConsignees).then(res => {
      $(".consigneesLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_CONSIGNEES", res.data.consignees);
      } else if (res.data.code === 404) {
        ers.errorLoadingConsignees();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        commit("STORE_CONSIGNEES", []);
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/consignees/actions.js